export const isNative: boolean = false
export const isAndroid: boolean = false
export const isIOS: boolean = false
